import { EntityInterface } from '../interfaces/entity.interface';

export class ReferenceEntity implements EntityInterface {
  uuid: string;
  constructor(uuid: string) {
    this.uuid = uuid;
  }
}
